import { MockNote } from '@/components/foundations';
import { AppShell, PageHeader, PageTitle } from '@/components/layout';
import { Button } from '@/components/forms';
import { Panel, StatCard } from '@/components/data';
import { SyncRunsTable } from './components';
import { SYNC_RUNS } from '@/mocks/financas';

/** Status da sincronização com a Pluggy — mock. */
export function FinSyncPage() {
  return (
    <AppShell>
      <main className="content">
        <PageHeader subtitle="Acompanhe as atualizações vindas da Pluggy." period="Outubro 2026" />
        <PageTitle variant="page" title="Sincronização" style={{ marginBottom: 0, alignItems: 'center' }} actions={<Button icon="refresh">Sincronizar agora</Button>} />
        <section className="stats">
          <StatCard icon="refresh" label="Último sync" value="hoje, 07:02" hint="via cron diário" />
          <StatCard icon="cal" label="Próximo sync" value="amanhã, 07:00" hint="horário de Brasília" />
          <StatCard icon="doc" label="Lançamentos" value="1.284" trend={{ dir: 'up', value: '14', text: 'novos hoje' }} />
          <StatCard icon="checkc" label="Status do item" value="UPDATED" hint="Inter PF" />
        </section>
        <Panel as="section" variant="recent" head="bar" title="Execuções recentes">
          <SyncRunsTable runs={SYNC_RUNS} />
        </Panel>
        <MockNote />
      </main>
    </AppShell>
  );
}
